var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 6.6368C16.94 3.01405 13.56 0.928223 10 0.928223C8.22 0.928223 6.49 1.44718 4.91 2.41525C3.33 3.39329 1.91 4.82044 0.75 6.6368C-0.25 8.20367 -0.25 10.7486 0.75 12.3154C3.06 15.9482 6.44 18.024 10 18.024C11.78 18.024 13.51 17.5051 15.09 16.537C16.67 15.559 18.09 14.1318 19.25 12.3154C20.25 10.7586 20.25 8.20367 19.25 6.6368ZM10 13.5131C7.76 13.5131 5.96 11.7067 5.96 9.48112C5.96 7.25557 7.76 5.44918 10 5.44918C12.24 5.44918 14.04 7.25557 14.04 9.48112C14.04 11.7067 12.24 13.5131 10 13.5131Z",
    fill: "#B6B5D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 6.62671C8.43039 6.62671 7.15039 7.90415 7.15039 9.481C7.15039 11.0479 8.43039 12.3253 10.0004 12.3253C11.5704 12.3253 12.8604 11.0479 12.8604 9.481C12.8604 7.91413 11.5704 6.62671 10.0004 6.62671Z",
    fill: "#B6B5D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9d002c5b024610bfd997e18205f3824b.svg";
export { ForwardRef as ReactComponent };